var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',{staticStyle:{"text-align":"center","margin":"40px"}},[_vm._v("Convert LaTeX to KaTeX")]),_c('Body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }